import React, { Component } from 'react';
import {
  Badge,
  Button,
  Col,
  Card,
  CardBody,
  FormGroup,
  Input,
  InputGroup,
  InputGroupButton,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  PaginationItem,
  PaginationLink,
  Row,
  Table
} from 'reactstrap';
import Pagination from '../../components/Pagination';

// Firebase
import { app } from '../../base';

const TableRow = (props) => {
  var status = parseInt(props.data.status) && 1;
  return (
    <tr>
      <td><img src={props.data.image || ''} height="64" width="64" /></td>
      <td>{props.data.name || ''}</td>
      <td align="center">
        <i className="fa fa-pencil fa-lg mr-1 icon-pointer" onClick={()=>props.viewForm(props.rowKey, props.data)}></i>
        <i className="fa fa-remove fa-lg icon-pointer" onClick={()=>props.deleteData(props.rowKey)}></i>
      </td>
    </tr>
  );
}

function ShowMessage(props) {
  return <div className="alert alert-info" role="alert" style={{display:props.show}}>{props.message}</div>;
}

class Brands extends Component {
  constructor() {
    super();
    var data = {
      image: '',
      name: ''
    };

    this.state = {
      data: data,
      modal: false,
      rows: [],
      pageOfItems: [],
      searchRows: [],
      show: 'none'
    };
    this.onChangePage = this.onChangePage.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.viewForm = this.viewForm.bind(this);
  }

  componentWillMount() {
    app.database().ref('/brands').on('value', (snapshot) => {
      var items = snapshot.val();
      var rows = [];
      for (var key in items) {
        rows.push(<TableRow key={key} data={items[key]} rowKey={key} viewForm={this.viewForm} deleteData={this.deleteData} />);
      }
      this.setState({
        rows:rows,
        searchRows: rows
      });
    });
  }

  deleteData(key) {
    if (confirm("Are you sure you want to delete this item?")) {
      app.database().ref('brands/' + key).remove()
      .catch((error)=>{
        alert(error.message);
      });
    }
  }

  filterData(searchText, element){
    return (element.props.data.name.toLowerCase().indexOf(searchText) != -1)
  }

  onChangePage(pageOfItems) {
    // update state with new page of items
    this.setState({ pageOfItems: pageOfItems });
  }

  onSearch(event) {
    event.preventDefault()

    const searchText = this.searchInput.value

    if (this.state.searchRows.length == 0) return;

    var rows = this.state.searchRows.filter(this.filterData.bind(this, searchText));
    this.setState({rows:rows});
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardBody>
                <Col md="4">
                  <FormGroup>
                    <form onSubmit={(event) => { this.onSearch(event) }} ref={(form) => { this.searchForm = form }}>
                      <InputGroup>
                        <Input size="10" type="text" placeholder="Enter text here" innerRef={(input) => { this.searchInput = input }}/>
                        <InputGroupButton>
                          <Button color="info">Search</Button>
                        </InputGroupButton>
                      </InputGroup>
                    </form>
                  </FormGroup>
                </Col>
                <Table bordered striped responsive size="sm">
                  <thead>
                  <tr>
                    <th>Image</th>
                    <th>Brand</th>
                    <th className="text-center">Action</th>
                  </tr>
                  </thead>
                  <tbody>{this.state.pageOfItems}</tbody>
                </Table>
                <nav>
                  <Pagination items={this.state.rows} onChangePage={this.onChangePage} />
                </nav>
                <Modal isOpen={this.state.modal} toggle={this.toggleModal} className='modal-lg'>
                  <form onSubmit={(event) => { this.updateData(event) }} ref={(form) => { this.editForm = form }}>
                  <ModalHeader toggle={this.toggleModal}>
                    <ShowMessage show={this.state.show} message={this.state.message} />
                  </ModalHeader>
                  <ModalBody>
                    <InputGroup className="mb-3">
                      <Input type="text" placeholder="Brand Name" innerRef={(input) => { this.nameInput = input }} defaultValue={this.state.data.name} />
                    </InputGroup>
                    <InputGroup className="mb-3">
                      <Input type="file" name="file" innerRef={(input) => { this.fileInput = input }} />
                    </InputGroup>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="primary">Update</Button>{' '}
                    <Button color="secondary" onClick={this.toggleModal}>Cancel</Button>
                  </ModalFooter>
                  </form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }

  setMessage(msg) {
    this.setState({
      message: msg,
      show: ''
    });
  }

  syncData(name, image) {
    let updateKey = {};
    updateKey.brand_name = name;
    if (image != '') {
      updateKey.brand_image = image;
    }
    let parentFind = app.database().ref('products').orderByChild('brand_id').equalTo(this.state.key);
    parentFind.on('child_added', snapshot=>{
      snapshot.ref.update(updateKey);
    });
  }

  toggleModal() {
    this.setState({
      modal: !this.state.modal
    });
  }

  updateData(event) {
    event.preventDefault()
    const name = this.nameInput.value
    const file = this.fileInput.files[0]
    const fileVal = this.fileInput.value
    //console.log(name+"-"+fileVal)

    if (name == '') {
      this.setMessage('All fields must be filled');
      return;
    }

    if (fileVal == '') {
      app.database().ref('brands/' + this.state.key).update({
        name: name
      })
      .then(()=>{
        this.syncData(name, '');
        this.setState({
          modal: !this.state.modal
        });
      })
      .catch((error)=>{
        this.setMessage(error.message);
      });
    }
    else {
      this.setMessage('Uploading...');
      
      var re = /(?:\.([^.]+))?$/;
      var ext = re.exec(fileVal)[1];

      var uploadRef = app.storage().ref().child('images/brands/'+this.state.key+'.'+ ext);
      var uploadTask = uploadRef.put(file);
      uploadTask.on('state_changed', (storeSnap)=>{
        //console.log('processing')
      }, (error)=>{
        this.setMessage('Upload error');
      }, ()=>{
        app.database().ref('brands/' + this.state.key).update({
          image: uploadTask.snapshot.downloadURL,
          name: name
        })
        .then(()=>{
          this.syncData(name, uploadTask.snapshot.downloadURL);
          this.setState({
            modal: !this.state.modal
          });
        })
        .catch((error)=>{
          uploadRef.delete();
          this.setMessage(error.message);
        });
      });
    }
  }

  viewForm(key, data) {
    this.setState({
      data: data,
      key: key,
      message: '',
      modal: !this.state.modal,
      show: 'none'
    });
  }
}

export default Brands;


// WEBPACK FOOTER //
// ./src/views/Brands/Brands.js